var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "auth-wrapper auth-v2"
  }, [_c('b-row', {
    staticClass: "auth-inner m-0"
  }, [_c('b-col', {
    staticClass: "d-none d-lg-flex align-items-center p-5",
    attrs: {
      "lg": "8"
    }
  }, [_c('div', {
    staticClass: "w-100 d-lg-flex align-items-center justify-content-center px-5"
  }, [_c('b-img', {
    attrs: {
      "fluid": "",
      "src": _vm.imgUrl,
      "alt": "Login V2"
    }
  })], 1)]), _c('b-col', {
    staticClass: "d-flex align-items-center auth-bg px-2 p-lg-5",
    attrs: {
      "lg": "4"
    }
  }, [_c('b-col', {
    staticClass: "px-xl-2 mx-auto",
    attrs: {
      "sm": "8",
      "md": "6",
      "lg": "12"
    }
  }, [_c('b-card-title', {
    staticClass: "mb-1 font-weight-bold",
    attrs: {
      "title-tag": "h2"
    }
  }, [_vm._v(" Bem-vindo ao ArboEdu! ")]), _c('b-card-text', {
    staticClass: "mb-2"
  }, [_vm._v(" Insira os seus dados para acessar o sistema ")]), _c('validation-observer', {
    ref: "loginForm",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var invalid = _ref.invalid;
        return [_c('b-form', {
          staticClass: "auth-login-form mt-2",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.login.apply(null, arguments);
            }
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Email",
            "label-for": "login-email"
          }
        }, [_c('validation-provider', {
          attrs: {
            "name": "Email",
            "vid": "email",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref2) {
              var errors = _ref2.errors;
              return [_c('b-form-input', {
                attrs: {
                  "id": "login-email",
                  "state": errors.length > 0 ? false : null,
                  "name": "login-email",
                  "placeholder": "Seu email"
                },
                model: {
                  value: _vm.userEmail,
                  callback: function callback($$v) {
                    _vm.userEmail = $$v;
                  },
                  expression: "userEmail"
                }
              }), _c('small', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1), _c('b-form-group', [_c('div', {
          staticClass: "d-flex justify-content-between"
        }, [_c('label', {
          attrs: {
            "for": "login-password"
          }
        }, [_vm._v("Senha")]), _c('b-link', {
          attrs: {
            "to": {
              name: 'auth-forgot-password'
            }
          }
        }, [_c('small', [_vm._v("Esqueceu a senha?")])])], 1), _c('validation-provider', {
          attrs: {
            "name": "Password",
            "vid": "password",
            "rules": "required"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref3) {
              var errors = _ref3.errors;
              return [_c('b-input-group', {
                staticClass: "input-group-merge",
                class: errors.length > 0 ? 'is-invalid' : null
              }, [_c('b-form-input', {
                staticClass: "form-control-merge",
                attrs: {
                  "id": "login-password",
                  "state": errors.length > 0 ? false : null,
                  "type": _vm.passwordFieldType,
                  "name": "login-password",
                  "placeholder": "Password"
                },
                model: {
                  value: _vm.password,
                  callback: function callback($$v) {
                    _vm.password = $$v;
                  },
                  expression: "password"
                }
              }), _c('b-input-group-append', {
                attrs: {
                  "is-text": ""
                }
              }, [_c('feather-icon', {
                staticClass: "cursor-pointer",
                attrs: {
                  "icon": _vm.passwordToggleIcon
                },
                on: {
                  "click": _vm.togglePasswordVisibility
                }
              })], 1)], 1), _c('small', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1), _c('b-form-group', [_c('b-form-checkbox', {
          attrs: {
            "id": "remember-me",
            "name": "checkbox-1"
          },
          model: {
            value: _vm.status,
            callback: function callback($$v) {
              _vm.status = $$v;
            },
            expression: "status"
          }
        }, [_vm._v(" Lembrar-me ")])], 1), _c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary",
            "block": "",
            "disabled": invalid
          }
        }, [_vm._v(" Login ")])], 1)];
      }
    }])
  }), _c('div', {
    staticClass: "mt-4 text-center"
  }, [_c('span', {
    staticClass: "text-muted d-block mb-1 font-small-3"
  }, [_vm._v("Apoio:")]), _c('div', {
    staticClass: "d-flex align-items-center justify-content-center flex-wrap"
  }, [_c('b-img', {
    staticClass: "mx-1 mb-1",
    staticStyle: {
      "max-height": "45px",
      "width": "auto"
    },
    attrs: {
      "src": _vm.baseUrl + 'assets/images/brasao-ufpe.png',
      "alt": "UFPE"
    }
  }), _c('b-img', {
    staticClass: "mx-1 mb-1",
    staticStyle: {
      "max-height": "35px",
      "width": "auto"
    },
    attrs: {
      "src": _vm.baseUrl + 'assets/images/capes.png',
      "alt": "CAPES"
    }
  }), _c('b-img', {
    staticClass: "mx-1 mb-1",
    staticStyle: {
      "max-height": "60px",
      "width": "auto"
    },
    attrs: {
      "src": _vm.baseUrl + 'assets/images/selo-ods-educacao.png',
      "alt": "ODS"
    }
  })], 1)])], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-estudante-app",
      "title": "Acesso Restrito",
      "size": "md",
      "centered": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('feather-icon', {
    staticClass: "text-primary",
    attrs: {
      "icon": "SmartphoneIcon",
      "size": "48"
    }
  })], 1), _c('h4', {
    staticClass: "mb-3"
  }, [_vm._v("Acesso via Aplicativo")]), _c('p', {
    staticClass: "mb-4"
  }, [_vm._v(" Estudantes devem acessar o sistema através do aplicativo móvel. ")]), _c('div', {
    staticClass: "mb-4"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "primary",
      "size": "lg",
      "href": "https://app.arboedu.org"
    }
  }, [_c('feather-icon', {
    staticClass: "mr-2",
    attrs: {
      "icon": "ExternalLinkIcon",
      "size": "16"
    }
  }), _vm._v(" Acessar App ")], 1)], 1)])]), _c('b-modal', {
    attrs: {
      "id": "modal-alterar-senha",
      "title": "Alteração de Senha Obrigatória",
      "size": "md",
      "centered": "",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": ""
    }
  }, [_c('div', {
    staticClass: "text-center mb-3"
  }, [_c('feather-icon', {
    staticClass: "text-warning",
    attrs: {
      "icon": "ShieldIcon",
      "size": "48"
    }
  })], 1), _c('h4', {
    staticClass: "text-center mb-4"
  }, [_vm._v("Alteração de Senha Necessária")]), _c('p', {
    staticClass: "text-center mb-4"
  }, [_vm._v(" Por motivos de segurança, você deve alterar sua senha antes de continuar. ")]), _c('validation-observer', {
    ref: "alterarSenhaForm",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var invalid = _ref4.invalid;
        return [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.alterarSenha.apply(null, arguments);
            }
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Nova Senha",
            "label-for": "nova-senha"
          }
        }, [_c('validation-provider', {
          attrs: {
            "name": "Nova Senha",
            "rules": "required|min:6"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref5) {
              var errors = _ref5.errors;
              return [_c('b-input-group', {
                staticClass: "input-group-merge",
                class: errors.length > 0 ? 'is-invalid' : null
              }, [_c('b-form-input', {
                attrs: {
                  "id": "nova-senha",
                  "type": _vm.passwordFieldType,
                  "placeholder": "Digite sua nova senha",
                  "state": errors.length > 0 ? false : null
                },
                model: {
                  value: _vm.novaSenha,
                  callback: function callback($$v) {
                    _vm.novaSenha = $$v;
                  },
                  expression: "novaSenha"
                }
              }), _c('b-input-group-append', {
                attrs: {
                  "is-text": ""
                }
              }, [_c('feather-icon', {
                staticClass: "cursor-pointer",
                attrs: {
                  "icon": _vm.passwordToggleIcon
                },
                on: {
                  "click": _vm.togglePasswordVisibility
                }
              })], 1)], 1), _c('small', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Confirmar Nova Senha",
            "label-for": "confirmar-senha"
          }
        }, [_c('validation-provider', {
          attrs: {
            "name": "Confirmar Senha",
            "rules": "required|min:6"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(_ref6) {
              var errors = _ref6.errors;
              return [_c('b-input-group', {
                staticClass: "input-group-merge",
                class: errors.length > 0 ? 'is-invalid' : null
              }, [_c('b-form-input', {
                attrs: {
                  "id": "confirmar-senha",
                  "type": _vm.passwordFieldType,
                  "placeholder": "Confirme sua nova senha",
                  "state": errors.length > 0 ? false : null
                },
                model: {
                  value: _vm.confirmarSenha,
                  callback: function callback($$v) {
                    _vm.confirmarSenha = $$v;
                  },
                  expression: "confirmarSenha"
                }
              }), _c('b-input-group-append', {
                attrs: {
                  "is-text": ""
                }
              }, [_c('feather-icon', {
                staticClass: "cursor-pointer",
                attrs: {
                  "icon": _vm.passwordToggleIcon
                },
                on: {
                  "click": _vm.togglePasswordVisibility
                }
              })], 1)], 1), _c('small', {
                staticClass: "text-danger"
              }, [_vm._v(_vm._s(errors[0]))])];
            }
          }], null, true)
        })], 1), _c('div', {
          staticClass: "text-center"
        }, [_c('b-button', {
          staticClass: "w-100",
          attrs: {
            "type": "submit",
            "variant": "primary",
            "size": "lg",
            "disabled": invalid || _vm.isChangingPassword
          }
        }, [_vm.isChangingPassword ? _c('b-spinner', {
          staticClass: "mr-1",
          attrs: {
            "small": ""
          }
        }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isChangingPassword ? 'Alterando...' : 'Alterar Senha') + " ")], 1)], 1)], 1)];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }